var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab-item',[_c('v-card-text',[(_vm.event.modpack)?_c('modlist-card',{attrs:{"modpack":_vm.event.modpack}}):_c('div',{staticClass:"text-body-1"},[_vm._v("No modpack assigned to this event.")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }